import { Controller } from "@hotwired/stimulus"
import { computePosition, flip, shift, offset, autoUpdate } from "@floating-ui/dom"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.isOpen = false
    this.boundClose = this.closeOnClickOutside.bind(this)
    this.cleanup = null
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose, true)
    this.stopAutoUpdate()
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.isOpen = true
    this.startAutoUpdate()
    requestAnimationFrame(() => {
      document.addEventListener("click", this.boundClose, true)
    })
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.isOpen = false
    this.stopAutoUpdate()
    document.removeEventListener("click", this.boundClose, true)
  }

  startAutoUpdate() {
    this.cleanup = autoUpdate(this.buttonTarget, this.menuTarget, () => {
      this.updatePosition()
    })
  }

  stopAutoUpdate() {
    if (this.cleanup) {
      this.cleanup()
      this.cleanup = null
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  async updatePosition() {
    const { x, y } = await computePosition(this.buttonTarget, this.menuTarget, {
      placement: "bottom-end",
      strategy: "fixed",
      middleware: [
        offset(4),
        flip({ fallbackPlacements: ["bottom-start", "top-end", "top-start"] }),
        shift({ padding: 8 })
      ]
    })

    Object.assign(this.menuTarget.style, {
      position: "fixed",
      left: `${x}px`,
      top: `${y}px`
    })
  }
}
